<template>
  <div id="bottom-banner">
    <img
      :class="{ bringUp: $screen.width <= 800 && !isCartEmpty && inMenuScreen }"
      id="donut"
      src="../assets/donut5.png"
      alt
    />
    <img
      :class="{ bringUp: $screen.width <= 800 && !isCartEmpty && inMenuScreen }"
      id="latte"
      src="../assets/latte.png"
      alt
    />
    <div id="big-logo">
      <a href="/">
        <h4 id="logo">
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 1000 500"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="146.66622"
                y1="184.19304"
                x2="262.92279"
                y2="300.44961"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="lightgrey" />
              </linearGradient>
              <linearGradient
                id="linear-gradient-2"
                x1="390.44199"
                y1="151.82273"
                x2="817.86754"
                y2="579.24829"
                xlink:href="#linear-gradient"
              />
            </defs>
            <g>
              <path
                d="M147.10346,264.0459,141.279,264.006l.14294-20.8753A128.8927,128.8927,0,0,1,271.19422,115.12358l5.82442.03988-.14294,20.87532A128.89269,128.89269,0,0,1,147.10346,264.0459ZM88.91677,257.046a63.91677,63.91677,0,1,0,63.91677,63.91677A63.91677,63.91677,0,0,0,88.91677,257.046Z"
                style="fill: url(#linear-gradient)"
              />
              <path
                d="M380.05067,315.68569H322.97926V380.5858H277.01864V209.11705H388.38438l4.2929,36.11272h-69.698V279.573h52.77851Zm32.829,64.90011V205.07705l45.96062-2.7779V380.5858ZM615.40553,258.36137V380.8379H593.18312l-13.1316-12.6258a147.998,147.998,0,0,1-13.88951,7.5758,107.02854,107.02854,0,0,1-17.04555,6.439,68.62935,68.62935,0,0,1-19.06636,2.65266q-15.4053,0-25.2524-6.18846a36.90135,36.90135,0,0,1-14.52056-16.9195,60.43752,60.43752,0,0,1-4.67185-24.36846V258.36137h45.96062v74.748A18.96874,18.96874,0,0,0,534.343,343.211q2.7759,4.545,10.35451,4.54581a30.85121,30.85121,0,0,0,7.449-1.13686q4.41613-1.13443,9.0916-2.7779,4.66905-1.63783,8.20685-3.15524V258.36137Zm116.41252,40.909H695.454v30.30481q0,7.575,3.914,11.99475a13.2898,13.2898,0,0,0,10.47975,4.419,37.67493,37.67493,0,0,0,8.5858-1.13685,32.69894,32.69894,0,0,0,9.09161-3.661l13.1316,31.31321a37.647,37.647,0,0,1-8.71265,5.05161,73.80627,73.80627,0,0,1-12.37371,4.16685,53.69312,53.69312,0,0,1-12.75265,1.64105,71.99869,71.99869,0,0,1-27.77821-5.429,50.20889,50.20889,0,0,1-21.33925-16.28846q-8.20846-10.85548-8.20686-27.02111V299.27038h-18.9403V263.15927h18.9403V230.07816l45.96062-6.3137v39.39481h32.07111Zm66.41351,31.56691a24.69963,24.69963,0,0,0,5.3029,8.8379,22.8456,22.8456,0,0,0,9.0916,5.80951,39.22867,39.22867,0,0,0,13.38371,2.02,62.69291,62.69291,0,0,0,19.57135-2.7779,105.19834,105.19834,0,0,0,14.01556-5.55581l12.8787,31.06111a53.59355,53.59355,0,0,1-12.8787,6.5658,102.618,102.618,0,0,1-17.92951,4.7979,114.44667,114.44667,0,0,1-20.2024,1.76791q-20.96433,0-37.62691-7.32371a59.0412,59.0412,0,0,1-26.13716-21.59055q-9.47055-14.26364-9.46975-34.97586,0-20.7042,8.71185-35.35481A58.6929,58.6929,0,0,1,780.681,261.64347a71.34213,71.34213,0,0,1,33.46005-7.8279q19.69741,0,32.703,8.71265a53.48242,53.48242,0,0,1,19.44451,23.23321,77.304,77.304,0,0,1,6.43975,31.69216v13.3837Zm30.55611-22.7274a20.23351,20.23351,0,0,0-1.64105-7.57581,17.88744,17.88744,0,0,0-5.0508-6.94475q-3.40935-2.89994-9.21766-2.90475a14.4516,14.4516,0,0,0-7.8279,2.399,17.09737,17.09737,0,0,0-5.93475,6.3137,17.81648,17.81648,0,0,0-2.146,8.71266Zm61.61481,72.47591V258.36137h22.9803l11.1108,14.89951a90.46778,90.46778,0,0,1,11.99556-6.94476,101.921,101.921,0,0,1,14.6466-5.8079,48.904,48.904,0,0,1,14.52056-2.399L975,294.97828a52.93208,52.93208,0,0,0-13.00555,1.7679,82.13247,82.13247,0,0,0-13.63661,4.7979,61.75556,61.75556,0,0,0-11.99475,7.07V380.5858Z"
                style="fill: url(#linear-gradient-2)"
              />
            </g>
          </svg>
        </h4>
      </a>
    </div>
    <div id="description-n-links">
      <div id="description">
        <h4 id="about-us">{{ labels.footerText[language] }}</h4>
      </div>
      <div id="links">
        <div id="some-links">
          <h4 @click="goToInfo('contact-us')">{{ labels.info.contact[language] }}</h4>
          <h4 @click="goToInfo('terms-of-service')">{{ labels.info.termsOfService[language] }}</h4>
          <h4 @click="goToInfo('privacy-policy')">{{ labels.info.privacyPolicy[language] }}</h4>
        </div>
        <div id="some-more-links">
          <h4 @click="goToInfo('rating-policy')">{{ labels.info.ratingPolicy[language] }}</h4>
          <h4 @click="goToInfo('cookies-policy')">{{ labels.info.cookiesPolicy[language] }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    isCartEmpty() {
      return this.$store.getters.getCartSize == 0;
    },

    inMenuScreen() {
      return this.$router.currentRoute.name.includes("menu");
    },

    language() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    goToMainScreen: function () {
      this.$router.push({ name: "search" });
    },

    goToInfo: function (type) {
      this.$router.push({ name: "specific-info", params: { type: type } });
    },
  },
};
</script>

<style scoped>
#bottom-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 45vh;
  background: #198b4a;
  /* background: #6cffac; */
  overflow: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

h4 {
  margin: 0;
}

#big-logo {
  width: 15%;
  margin: 2% 0 0% 10%;
}

#description-n-links {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
}

#description {
  width: 35%;
  margin-left: 10%;
  display: flex;
  white-space: pre-wrap;
}

#about-us {
  width: 100%;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 25px;
  margin-bottom: 40px;
}

#links {
  width: 65%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* background: blue; */
}

#some-links,
#some-more-links {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #fff;
  font-size: 15px;
}

#some-links > h4,
#some-more-links > h4 {
  font-weight: 400;
  margin-bottom: 0.85rem;
  cursor: pointer;
}

#some-links > h4:hover,
#some-more-links > h4:hover {
  text-decoration: underline;
}

#logo {
  cursor: pointer;
}

#donut {
  position: absolute;
  bottom: -80px;
  left: -90px;
  width: 200px;
  height: 200px;
}

#latte {
  position: absolute;
  bottom: -60px;
  right: -30px;
  width: 160px;
  height: 200px;
  transform: rotateZ(-30deg);
}

.bringUp {
  margin-bottom: 9vh;
}

@media (max-width: 1100px) {
  #donut {
    bottom: -75px;
    left: -85px;
    width: 190px;
    height: 190px;
  }

  #latte {
    bottom: -60px;
    right: -30px;
    width: 155px;
    height: 190px;
  }
}

@media (max-width: 1000px) {
  #donut {
    bottom: -70px;
    left: -80px;
    width: 170px;
    height: 170px;
  }

  #latte {
    bottom: -60px;
    right: -30px;
    width: 150px;
    height: 170px;
  }
}

@media (max-width: 800px) {
  #big-logo {
    width: 80%;
    margin: 3% 0 0 8%;
    align-items: center;
    justify-content: center;
  }

  #logo {
    margin: 0;
    text-align: center;
  }

  #description-n-links {
    flex-direction: column;
  }

  #description {
    width: 80%;
    margin-left: 10%;
    display: flex;
  }

  #about-us {
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    margin-bottom: 40px;
  }

  #links {
    width: 100%;
    margin-bottom: 20vh;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
  }
}

@media (max-height: 700px) and (max-width: 800px) {
  #links {
    margin-bottom: 23vh;
  }
}

@media (max-width: 300px) {
  #some-links,
  #some-more-links {
    font-size: 12px;
  }
}
</style>